export enum StoreActionsEnum {

    NONE = 'NONE',

    // app init action
    // APP_INIT = 'APP_INIT',

    // UI config
    LOAD_CONFIG = 'LOAD_CONFIG',
    CONFIG_LOADED = 'CONFIG_LOADED',

    // list of polls
    POLLS_LOADED = 'POLLS_LOADED',

    // poll
    LOAD_ENTIRE_POLL = 'LOAD_ENTIRE_POLL',
    ENTIRE_POLL_LOADED = 'ENTIRE_POLL_LOADED',
    UPDATE_BTPOLL = 'UPDATE_BTPOLL',
    BTPOLL_LOADED = 'BTPOLL_LOADED',
    DELETE_POLL = 'DELETE_POLL',
    POLL_DELETED = 'POLL_DELETED',
    RESET_POLL = 'RESET_POLL',  // used to clear poll in store
    INSERT_BTPOLL = 'INSERT_BTPOLL',
    POLL_INSERTED = 'POLL_INSERTED',
    COPY_POLL = 'COPY_POLL',
    CHANGE_POLL_AUDIENCE = 'CHANGE_POLL_AUDIENCE',

    PUBLISH_POLL = 'PUBLISH_POLL',
    POLL_PUBLISHED = 'POLL_PUBLISHED',
    UNPUBLISH_POLL = 'UNPUBLISH_POLL',
    POLL_UNPUBLISHED = 'POLL_UNPUBLISHED',

    DELETE_POLL_RESULTS = 'DELETE_POLL_RESULTS',
    POLL_RESULTS_DELETED = 'POLL_RESULTS_DELETED',

    // questions
    UPDATE_QUESTIONS = 'UPDATE_QUESTIONS',
    QUESTIONS_UPDATED = 'QUESTIONS_UPDATED',
    REPLACE_ALL_QUESTIONS_AND_SCRIPTQUESTSETS = 'REPLACE_ALL_QUESTIONS_AND_SCRIPTQUESTSETS',
    ALL_QUESTIONS_AND_SCRIPTQUESTSETS_REPLACED = 'ALL_QUESTIONS_AND_SCRIPTQUESTSETS_REPLACED',

    DELETE_QUESTIONS = 'DELETE_QUESTIONS',
    QUESTIONS_DELETED = 'QUESTIONS_DELETED',

    // ScriptQuestSets
    UPDATE_ALL_SCRIPTQUESTSETS = 'UPDATE_ALL_SCRIPTQUESTSETS',
    SCRIPTQUESTSETS_UPDATED = 'SCRIPTQUESTSETS_UPDATED',

    // Scripts
    REPLACE_ALL_SCRIPTS_AND_SCRIPTQUESTSETS = 'REPLACE_ALL_SCRIPTS_AND_SCRIPTQUESTSETS',

    // Actions
    EMAIL_RESPONSES_TO_ME = 'EMAIL_RESPONSES_TO_ME',


    // Misc
    LAST_POLL_LIST_LINK = 'LAST_POLL_LIST_LINK' // link to poll/list page with query params

}
